export enum BoardTypeEnum {
  HOLISTIC = "Holistic",
  BACKLOG = "Backlog",
  INTERACTIVE_REMINDERS = "Interactive reminders",
  INITIATIVE_MANAGEMENT = "Initiative management",
  WORK_AUTOMATION = "Work automation",
  GUESSTIMATION = "Guesstimation",
}
